import { Bones, Box, Grid, Text } from '@simplywallst/ui-core';

export const TileSkeleton = () => (
  <Box borderRadius="x1" boxShadow="strongBorder" height={310}>
    <Grid templateRows="48px auto 48px">
      <Grid templateColumns="150px auto" padding="x1">
        <Grid>
          <Bones margin="x0_5" />
          <Bones margin="x0_5" />
        </Grid>
        <Grid justifyContent="flex-end" padding="x1">
          <Grid
            width={40}
            height={40}
            borderRadius="x4"
            boxShadow="strongBorder"
          >
            <Bones borderRadius="x4" />
          </Grid>
        </Grid>
      </Grid>
      <Grid alignItems="center" justifyContent="center" height={195}>
        <Bones margin="x1" />
      </Grid>
      <Grid
        templateColumns="1fr 1fr 1fr 50px"
        alignItems="flex-end"
        padding="x1"
      >
        <Box>
          <Bones margin="x1" />
          <Bones margin="x1" />
        </Box>
        <Box margin="x1">
          <Text typography="xSmall" color="whiteRGBA" opacity={0.7}>
            7D
          </Text>
          <Bones />
        </Box>
        <Box margin="x1">
          <Text typography="xSmall" color="whiteRGBA" opacity={0.7}>
            1Y
          </Text>
          <Bones />
        </Box>
      </Grid>
    </Grid>
  </Box>
);
